import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from 'contexts/auth-context';
import { ContentProvider } from 'contexts/content-context';
import { apiInit } from 'utils/apiClient';

import { Notification } from 'components/common/Elements/Elements';

import Layout from 'components/Layout/Layout';

import classes from 'App.module.scss';

apiInit();

function App({ mixpanel }) {
  const [isNotif, setIsNotif] = useState(false);
  const [textNotif, setTextNotif] = useState('');
  const [loaderNotif, setLoaderNotif] = useState(false);
  mixpanel.track('App open in browser');
  const onOfNotif = (mode, text, loader, time) => {
    if (mode === 'on') {
      setTextNotif(text);
      setLoaderNotif(loader);
      setIsNotif(true);
      if (time) {
        setTimeout(() => {
          setTextNotif('');
          setIsNotif(false);
          setLoaderNotif(false);
        }, time);
      }
    } else if (mode === 'off') {
      setTextNotif('');
      setIsNotif(false);
      setLoaderNotif(false);
    }
  };

  return (
    <div className={classes.app}>
      <AuthProvider>
        <BrowserRouter>
          <ContentProvider>
            {isNotif && (
              <Notification
                text={textNotif}
                loader={loaderNotif}
                onClose={() => setIsNotif(false)}
              />
            )}
            <Layout onOfNotif={onOfNotif} />
          </ContentProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
